export const SHORT_ID_LENGTH = 6;
